import stateController from './stateController';
const articleSelectorContainer = document.querySelector('.article-selector-container');
const articleSelector = document.querySelector('.article-selector');
const data = require('./data/data');
const sections = data.sections;

const containerWidth = articleSelectorContainer.getBoundingClientRect().width;

const scrollSlideTo = index => {
    const artPoints = [...articleSelector.querySelectorAll('.article-selector__item')];
    if (artPoints.length < 3) {
        return;
    }
    const curArtDim = artPoints[index].getBoundingClientRect();
    if (curArtDim.x + curArtDim.width > containerWidth) {
        articleSelectorContainer.scrollLeft = containerWidth + curArtDim.width;
    } else if (curArtDim.x < 0) {
        articleSelectorContainer.scrollLeft -= curArtDim.x;
    }
};

const articleSelectorController = (function() {
    function _changeArticle(e) {
        stateController.gotoArticle(e.target.dataset.article);
    }
    function _addNewArticles(newArticles) {
        if (newArticles.length === 1) {
            articleSelector.classList.remove('hide');
            return;
        }
        newArticles.forEach((article, key) => {
            const newLink = document.createElement('li');
            newLink.className = 'article-selector__item';
            newLink.innerText = ('0' + (key + 1)).slice(-2);
            newLink.dataset.article = key;
            newLink.addEventListener('click', _changeArticle);
            articleSelector.appendChild(newLink);
        });
        articleSelector.classList.remove('hide');
    }
    function switchArticle(index) {
        scrollSlideTo(index);
    }
    function init(section) {
        const newArticles = sections[parseInt(section)].article;
        const selectorSectionsOld = [...articleSelector.querySelectorAll('.article-selector__item')];
        articleSelector.classList.add('hide');
        setTimeout(() => {
            selectorSectionsOld.forEach(item => {
                item.removeEventListener('click', _changeArticle);
                // TODO: сделать красивое удаление секций
                item.remove();
            });
            _addNewArticles(newArticles);
        }, 600);
    }
    return {
        init: init,
        switchArticle: switchArticle
    };
})();
export default articleSelectorController;
